import { render, staticRenderFns } from "./FormVehicleInspection.vue?vue&type=template&id=e8aba4e0"
import script from "./FormVehicleInspection.vue?vue&type=script&lang=js"
export * from "./FormVehicleInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormVehicleInspection.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8aba4e0')) {
      api.createRecord('e8aba4e0', component.options)
    } else {
      api.reload('e8aba4e0', component.options)
    }
    module.hot.accept("./FormVehicleInspection.vue?vue&type=template&id=e8aba4e0", function () {
      api.rerender('e8aba4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/components/FormVehicleInspection.vue"
export default component.exports